import React, { useEffect, useState } from "react";

import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import {
  Paper,
  Box,
  Grid,
  Button,
  Typography,
  Link,
  SvgIcon,
  useMediaQuery,
} from "@mui/material";
import { MenuOutlined } from "@ant-design/icons";

function TradesPage(props) {
  const mobileView = useMediaQuery("(max-width:600px)"); // For mobile devices

  const [mobileMenu, setMobileMenu] = useState(false);
  const [currentOption, setCurrentOption] = useState(0);
  const tradespersons = [
    "Electrician",
    "Plumber",
    "Mason",
    "Carpenter",
    "Painter",
    "Finisher",
    "Home Inspector",
    "Snow clearing",
    "Pest Controller",
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentOption((prevOption) =>
        prevOption === tradespersons.length - 1 ? 0 : prevOption + 1
      );
    }, 2000); // Change tradesperson every 2 seconds

    return () => clearTimeout(timer);
  }, [currentOption, tradespersons.length]);

  // Function to check if a letter is a vowel
  // const isVowel = (letter) => {
  //   return ["a", "e", "i", "o", "u"].includes(letter.toLowerCase());
  // };
  const theme = createTheme({
    palette: {
      primary: {
        main: "#fff",
        light: "#77c7a2",
        dark: "#017a46",
        contrastText: "#fff",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      {/* <Container
        sx={{
          padding: "0",
          width: "100%",
          height: "fit-content",
          display: "flex",
          justifyContent: "center", // Center horizontally
          borderRadius: "10px",
        }}
      > */}
      <Paper
        sx={{
          borderBottom: "none",
          // position: "relative",
          backgroundColor: "#fff",
          mb: 4,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          margin: "0",
          padding: "0",
          paddingBottom: "1rem",
          overflowX: "hidden",
          overflowY: "hidden",
          width: "100% !important",
          height: "fit-content !important",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundImage: `linear-gradient(rgba(1, 82, 47, 0.85), rgba(1, 82, 47, 0.85)), url(${require("../../images/cropped_trades.png")})`,
            backgroundSize: "cover", // Ensure the image covers the box
            backgroundRepeat: "no-repeat", // Prevent tiling
            backgroundPosition: "center", // Center the image
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              width: "100%",
              top: 11,
              left: 1,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Link href="/">
              <img
                id="logo"
                alt="logo"
                // className="Logo"
                src={require("../../icons/FixDenLogo.png")}
                width={mobileView ? "20%" : "130"}
                height={mobileView ? "auto" : "47"}
                style={{
                  marginTop: mobileView ? "4%" : 30,
                  marginLeft: mobileView ? "1%" : 30,
                }}
              />
            </Link>
            {!mobileView ? (
              <Box sx={{ marginRight: "30px" }}>
                <Button
                  id="need_services_btn"
                  variant="outlined"
                  color="primary"
                  style={{
                    width: mobileView ? "" : "176px",
                    height: mobileView ? "" : "48px",
                    marginTop: mobileView ? "4%" : "39px",
                    borderRadius: "9999px",
                  }}
                >
                  <Link href="/" underline="none">
                    <Typography
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: "16px",
                        textAlign: "center",
                      }}
                    >
                      Need Services?
                    </Typography>
                  </Link>
                </Button>

                <Button
                  id="log_in_btn"
                  variant="outlined"
                  color="primary"
                  style={{
                    width: mobileView ? "" : "111px",
                    height: mobileView ? "" : "48px",
                    marginTop: mobileView ? "4%" : "39px",
                    marginLeft: mobileView ? "1%" : "10px",
                    borderRadius: "9999px",
                  }}
                >
                  <Link href="/login" underline="none">
                    <Typography
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: "16px",
                        textAlign: "center",
                      }}
                    >
                      Log In
                    </Typography>
                  </Link>
                </Button>

                <Button
                  id="sign_up_btn"
                  variant="filled"
                  color="primary"
                  sx={{
                    backgroundColor: "#77C7A2",
                    width: mobileView ? "" : "124px",
                    height: mobileView ? "" : "48px",
                    marginTop: mobileView ? "4%" : "39px",
                    marginLeft: mobileView ? "1%" : "10px",
                    borderRadius: "9999px",
                    "&:hover": {
                      backgroundColor: "#509d79", // Set hover background color
                    },
                  }}
                >
                  <Link href="/signup" underline="none">
                    <Typography
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: "16px",
                        textAlign: "center",
                      }}
                    >
                      Sign Up
                    </Typography>
                  </Link>
                </Button>
              </Box>
            ) : (
              <MenuOutlined
                style={{ color: "#FFF", marginRight: "30px" }}
                onClick={() => {
                  console.log("Menu Clicked");
                  setMobileMenu(!mobileMenu);
                }}
              />
            )}
            {mobileMenu && (
              <Box
                sx={{
                  backgroundColor: "#012e1b80",
                  position: "absolute",
                  top: 30,
                  right: 30,
                  width: "10rem",
                  height: "7rem",
                  zIndex: 100,
                  padding: "0.75rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  borderRadius: "7px",
                }}
              >
                <Link href="/" underline="none">
                  <Typography
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Brockmann",
                      fontSize: 32,
                      fontWeight: 400,
                      lineHeight: "16px",
                      textAlign: "right",
                    }}
                  >
                    Need Services?
                  </Typography>
                </Link>
                <Link href="/login" underline="none">
                  <Typography
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Brockmann",
                      fontSize: 32,
                      fontWeight: 400,
                      lineHeight: "16px",
                      textAlign: "right",
                    }}
                  >
                    Log In
                  </Typography>
                </Link>
                <Link href="/signup" underline="none">
                  <Typography
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Brockmann",
                      fontSize: 32,
                      fontWeight: 400,
                      lineHeight: "16px",
                      textAlign: "right",
                    }}
                  >
                    Sign Up
                  </Typography>
                </Link>
              </Box>
            )}
          </Grid>

          <Box
            sx={{
              width: "100%",
              height: mobileView ? "30rem" : "20rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Grid item sx={{ position: "absolute", top: "50%" }}>
              <Typography
                className="description" // Added class name for targeting
                style={{
                  color: "#FFFFFF",
                  fontFamily: "Brockmann",
                  fontSize: mobileView ? "20px" : "48px",
                  fontWeight: 400,
                  lineHeight: mobileView ? "auto" : "55.2px",
                  textAlign: "center",
                }}
              >
                Are you a tradesperson? We’ve got work for you!
              </Typography>

              {/* {tradespersons.map((tradesperson, index) => (
              <Typography
                style={{
                  color: "#FFFFFF",
                  fontFamily: "Brockmann",
                  fontSize: 48,
                  fontWeight: 400,
                  lineHeight: "55.2px",
                  textAlign: "center"
                }}
              >
                <div
                  key={index}
                  style={{
                    display: index === currentOption ? "block" : "none"
                  }}
                >
                  {tradesperson}
                </div>
              </Typography>
            ))} */}
            </Grid>
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: mobileView ? "40%" : "271px",
              height: mobileView ? "10%" : "56px",
              borderRadius: "9999px",
              backgroundColor: "#77C7A2",
              alignSelf: "center",
              "&:hover": {
                backgroundColor: "#509d79",
              },
            }}
          >
            <Grid
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                width: "100%",
                height: "100%",
              }}
            >
              <Link
                href="/signup"
                underline="none"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#FFFFFF",
                  "&:hover": { color: "#FFFFFF" },
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontFamily: "Brockmann",
                    fontWeight: 400,
                    lineHeight: "16px",
                    textAlign: "center",
                  }}
                >
                  I need work
                </Typography>
                <SvgIcon
                  component="svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5 6.5L19.8728 11.8716C19.9576 11.9549 20 12.0641 20 12.1733M14.5 17.5L19.8728 12.475C19.9576 12.3917 20 12.2825 20 12.1733M20 12.1733H4"
                    stroke="#FFFFFF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </SvgIcon>
              </Link>
            </Grid>
            {/* </Box> */}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexDirection: "column",
            width: "100%",
            // backgroundColor: "#77C7A2",
            marginTop: "4rem",
            paddingBottom: "2rem",
          }}
        >
          <Box>
            <Grid item>
              <Typography
                className="work"
                style={{
                  color: "#04512F",
                  fontFamily: "Brockmann",
                  fontSize: 48,
                  fontWeight: 400,
                  lineHeight: mobileView ? "130%" : "55.2px",
                  textAlign: "center",
                }}
              >
                FixDen connects you with people looking for your skills.
              </Typography>
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: mobileView ? "column" : "row",
            justifyContent: "space-evenly",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: mobileView ? "100%" : "25%",
              gap: "1rem",
            }}
          >
            <svg
              width={mobileView ? "65%" : "113px"}
              height={mobileView ? "15%" : "113px"}
              viewBox="0 0 113 113"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1610_4065)">
                <path
                  d="M56.46 112.92C87.642 112.92 112.92 87.642 112.92 56.46C112.92 25.278 87.642 0 56.46 0C25.278 0 0 25.278 0 56.46C0 87.642 25.278 112.92 56.46 112.92Z"
                  fill="#FCF2E7"
                />
                <path
                  d="M37.5 62.6504V72.8104L39.42 81.1104L43.09 88.2304L50.94 89.7704L60.69 91.4704L67.98 88.0504L71.65 83.3904L73.74 75.8804L61.91 75.4604L59.47 78.0104L55.49 81.1104L52 80.1904L51.59 75.1604L50.94 65.5704L37.5 62.6504Z"
                  fill="#77C7A2"
                />
                <path
                  d="M55.49 81.11C51.97 81.11 49.27 78.67 49.06 75.31C48.85 71.96 48.84 60.27 49.02 37.42V36.76C49.02 36.06 49.59 35.5 50.29 35.5C50.99 35.5 51.55 36.07 51.55 36.76C51.55 36.79 51.55 37.02 51.55 37.44C51.37 60.24 51.38 71.87 51.58 75.16C51.7 77.17 53.31 78.58 55.48 78.58C57.38 78.58 59.26 77.04 59.37 75.41C59.37 74.37 59.35 67.34 59.33 62.61V62.36C59.33 62.36 59.33 62.29 59.33 62.26L59.35 62.02C60.02 53.51 66.59 47.38 72.73 45.71C73.68 45.45 75.21 45.14 78.71 44.97C79.41 44.93 80 45.48 80.03 46.17C80.06 46.87 79.52 47.46 78.83 47.49C75.53 47.65 74.15 47.94 73.39 48.14C68.1 49.57 62.45 54.86 61.87 62.2V62.39L61.86 62.58C61.88 67.04 61.91 74.48 61.9 75.44C61.9 75.46 61.9 75.48 61.9 75.51C61.73 78.49 58.74 81.1 55.48 81.1L55.49 81.11Z"
                  fill="#01522F"
                />
                <path
                  d="M55.49 92.9505C50.86 92.9505 46.46 91.2705 43.09 88.2305C39.61 85.0905 37.54 80.7605 37.25 76.0405C36.97 71.4205 37.06 54.7005 37.19 37.3305V36.7305C37.2 36.0405 37.77 35.4805 38.46 35.4805H38.47C39.17 35.4805 39.73 36.0605 39.72 36.7605V37.3505C39.63 48.1805 39.45 70.7105 39.77 75.8805C40.02 79.9305 41.8 83.6505 44.78 86.3405C47.68 88.9605 51.48 90.4105 55.48 90.4105C59.48 90.4105 63.28 88.9105 66.26 86.1705C69.29 83.3905 71.05 79.7005 71.2 75.7905C71.2 75.5805 71.21 74.0005 71.16 62.8505C71.16 62.8005 71.16 62.7405 71.16 62.6905C71.53 59.6505 74.15 57.5805 75.81 57.1305C76.05 57.0705 76.73 56.9305 78.49 56.8305C79.19 56.7805 79.79 57.3205 79.83 58.0205C79.87 58.7205 79.34 59.3205 78.64 59.3605C76.97 59.4605 76.46 59.5805 76.44 59.5805C75.77 59.7605 73.95 61.0305 73.68 62.9305C73.73 75.3405 73.72 75.7105 73.71 75.8805C73.53 80.4805 71.49 84.8005 67.95 88.0405C64.51 91.2005 60.07 92.9405 55.46 92.9405L55.49 92.9505Z"
                  fill="#01522F"
                />
                <path
                  d="M86.8 61.0898H81.14C78.36 61.0898 77.11 56.4398 77.11 51.8398C77.11 47.2398 78.35 42.5898 81.14 42.5898H86.8C89.58 42.5898 90.83 47.2398 90.83 51.8398C90.83 56.4398 89.59 61.0898 86.8 61.0898ZM81.2 58.5598H86.74C87.22 58.2498 88.3 55.9898 88.3 51.8398C88.3 47.6898 87.22 45.4198 86.74 45.1198H81.2C80.72 45.4298 79.64 47.6898 79.64 51.8398C79.64 55.9898 80.72 58.2598 81.2 58.5598Z"
                  fill="#01522F"
                />
                <path
                  d="M86.69 61.0906C83.51 61.0906 83.35 53.7206 83.35 52.2406C83.35 50.7606 83.51 43.3906 86.69 43.3906C87.39 43.3906 87.95 43.9606 87.95 44.6506C87.95 45.2506 87.53 45.7606 86.97 45.8806C86.56 46.4106 85.88 48.6806 85.88 52.2306C85.88 55.7806 86.57 58.0506 86.97 58.5806C87.53 58.7106 87.95 59.2106 87.95 59.8106C87.95 60.5106 87.38 61.0706 86.69 61.0706V61.0906Z"
                  fill="#01522F"
                />
                <path
                  d="M44.22 38.22C39.61 38.22 34.97 36.98 34.97 34.19V28.53C34.97 25.75 39.62 24.5 44.22 24.5C48.82 24.5 53.47 25.74 53.47 28.53V34.19C53.47 36.97 48.82 38.22 44.22 38.22ZM37.49 34.13C37.8 34.61 40.06 35.69 44.21 35.69C48.36 35.69 50.63 34.61 50.93 34.13V28.59C50.62 28.11 48.36 27.03 44.21 27.03C40.06 27.03 37.79 28.11 37.49 28.59V34.13Z"
                  fill="#01522F"
                />
                <path
                  d="M44.62 31.9809C43.14 31.9809 35.77 31.8209 35.77 28.6409C35.77 27.9409 36.34 27.3809 37.03 27.3809C37.63 27.3809 38.14 27.8009 38.26 28.3609C38.79 28.7709 41.06 29.4509 44.61 29.4509C48.16 29.4509 50.43 28.7609 50.96 28.3609C51.09 27.8009 51.59 27.3809 52.19 27.3809C52.89 27.3809 53.45 27.9509 53.45 28.6409C53.45 31.8209 46.08 31.9809 44.6 31.9809H44.62Z"
                  fill="#01522F"
                />
                <path
                  d="M44.4399 59.2991C43.2799 59.2991 37.5099 59.1591 37.5099 56.3791C37.5099 55.6791 38.08 55.1191 38.77 55.1191C39.34 55.1191 39.8299 55.4991 39.9799 56.0291C40.4399 56.3291 42.0299 56.7791 44.4399 56.7791C46.8499 56.7791 48.4299 56.3191 48.8899 56.0291C49.0399 55.5091 49.5299 55.1191 50.0999 55.1191C50.7999 55.1191 51.36 55.6891 51.36 56.3791C51.36 59.1591 45.58 59.2991 44.43 59.2991H44.4399Z"
                  fill="#01522F"
                />
                <path
                  d="M44.4399 65.5706C43.2799 65.5706 37.5099 65.4306 37.5099 62.6506C37.5099 61.9506 38.08 61.3906 38.77 61.3906C39.34 61.3906 39.8299 61.7706 39.9799 62.3006C40.4399 62.6006 42.0299 63.0506 44.4399 63.0506C46.8499 63.0506 48.4299 62.5906 48.8899 62.3006C49.0399 61.7806 49.5299 61.3906 50.0999 61.3906C50.7999 61.3906 51.36 61.9606 51.36 62.6506C51.36 65.4306 45.58 65.5706 44.43 65.5706H44.4399Z"
                  fill="#01522F"
                />
                <path
                  d="M66.41 70.5706C65.25 70.5706 59.48 70.4306 59.48 67.6506C59.48 66.9506 60.05 66.3906 60.74 66.3906C61.31 66.3906 61.8 66.7706 61.95 67.3006C62.41 67.6006 64 68.0506 66.41 68.0506C68.82 68.0506 70.4 67.5906 70.86 67.3006C71.01 66.7806 71.5 66.3906 72.07 66.3906C72.77 66.3906 73.33 66.9606 73.33 67.6506C73.33 70.4306 67.55 70.5706 66.4 70.5706H66.41Z"
                  fill="#01522F"
                />
                <path
                  d="M66.41 76.8401C65.25 76.8401 59.48 76.7002 59.48 73.9202C59.48 73.2202 60.05 72.6602 60.74 72.6602C61.31 72.6602 61.8 73.0402 61.95 73.5702C62.41 73.8702 64 74.3202 66.41 74.3202C68.82 74.3202 70.4 73.8602 70.86 73.5702C71.01 73.0502 71.5 72.6602 72.07 72.6602C72.77 72.6602 73.33 73.2302 73.33 73.9202C73.33 76.7002 67.55 76.8401 66.4 76.8401H66.41Z"
                  fill="#01522F"
                />
                <path
                  d="M98.53 67.1598C96.41 67.1598 94.6 65.3398 94.13 62.7298C93.72 60.4598 91.77 59.7798 91.75 59.7698C91.21 59.5898 90.86 59.0698 90.89 58.5098C90.92 57.9398 91.32 57.4698 91.87 57.3398C92.59 57.1798 93.33 57.0898 94.05 57.0898C97.99 57.0898 100.86 59.4498 101.85 61.6398C102.54 63.1698 102.39 64.6698 101.44 65.7498C100.64 66.6598 99.6 67.1598 98.53 67.1598ZM95.62 59.7998C96.07 60.4598 96.43 61.2698 96.62 62.2798C96.9 63.8098 97.81 64.6298 98.53 64.6298C98.88 64.6298 99.22 64.4398 99.55 64.0698C99.91 63.6598 99.7 63.0198 99.55 62.6798C99 61.4698 97.56 60.2498 95.63 59.7998H95.62Z"
                  fill="#01522F"
                />
                <path
                  d="M35.37 15.2802C35.66 15.2802 35.94 15.1602 36.14 14.9602C36.34 14.7602 36.46 14.4802 36.46 14.1902C36.46 13.9002 36.34 13.6202 36.14 13.4202C36.09 13.3702 36.04 13.3202 35.98 13.2802C35.92 13.2402 35.86 13.2102 35.79 13.1802C35.72 13.1502 35.66 13.1302 35.58 13.1202C35.44 13.0902 35.3 13.0902 35.16 13.1202C35.09 13.1302 35.02 13.1602 34.96 13.1802C34.89 13.2102 34.83 13.2402 34.77 13.2802C34.71 13.3202 34.65 13.3602 34.61 13.4202C34.41 13.6202 34.29 13.9002 34.29 14.1902C34.29 14.2602 34.29 14.3302 34.31 14.4002C34.32 14.4702 34.34 14.5402 34.37 14.6002C34.4 14.6702 34.43 14.7302 34.47 14.7902C34.51 14.8502 34.56 14.9102 34.61 14.9502C34.81 15.1502 35.09 15.2702 35.38 15.2702L35.37 15.2802Z"
                  fill="#01522F"
                />
                <path
                  d="M81.54 33.9295C81.61 33.9295 81.68 33.9295 81.75 33.9095C81.82 33.8995 81.89 33.8695 81.95 33.8495C82.02 33.8195 82.08 33.7895 82.14 33.7495C82.2 33.7095 82.26 33.6695 82.31 33.6195C82.36 33.5695 82.41 33.5095 82.44 33.4495C82.48 33.3895 82.51 33.3295 82.54 33.2595C82.57 33.1895 82.59 33.1295 82.6 33.0595C82.61 32.9895 82.62 32.9195 82.62 32.8495C82.62 32.7795 82.62 32.7095 82.6 32.6395C82.59 32.5695 82.56 32.4995 82.54 32.4395C82.51 32.3695 82.48 32.3095 82.44 32.2495C82.4 32.1895 82.35 32.1295 82.3 32.0795C82.05 31.8295 81.67 31.7095 81.32 31.7795C81.25 31.7895 81.18 31.8195 81.12 31.8395C81.05 31.8695 80.99 31.8995 80.93 31.9395C80.87 31.9795 80.81 32.0195 80.76 32.0695C80.71 32.1195 80.66 32.1795 80.63 32.2395C80.59 32.2995 80.56 32.3595 80.53 32.4295C80.5 32.4995 80.48 32.5595 80.47 32.6295C80.46 32.6995 80.45 32.7695 80.45 32.8395C80.45 32.9095 80.45 32.9795 80.47 33.0495C80.48 33.1195 80.51 33.1895 80.53 33.2495C80.56 33.3195 80.59 33.3795 80.63 33.4395C80.67 33.4995 80.71 33.5595 80.76 33.6095C80.81 33.6595 80.87 33.7095 80.93 33.7395C80.99 33.7795 81.05 33.8095 81.12 33.8395C81.19 33.8695 81.25 33.8895 81.32 33.8995C81.39 33.9095 81.46 33.9195 81.53 33.9195L81.54 33.9295Z"
                  fill="#01522F"
                />
                <path
                  d="M24.69 68.6895C24.98 68.6895 25.26 68.5695 25.46 68.3695C25.66 68.1695 25.78 67.8895 25.78 67.5995C25.78 67.3095 25.66 67.0295 25.46 66.8295C25.41 66.7795 25.35 66.7295 25.29 66.6895C25.23 66.6495 25.17 66.6195 25.1 66.5895C25.03 66.5595 24.97 66.5395 24.9 66.5295C24.55 66.4595 24.17 66.5795 23.92 66.8295C23.87 66.8795 23.82 66.9395 23.79 66.9895C23.75 67.0495 23.72 67.1095 23.69 67.1795C23.66 67.2495 23.64 67.3095 23.63 67.3795C23.62 67.4495 23.61 67.5195 23.61 67.5895C23.61 67.8795 23.73 68.1595 23.93 68.3595C24.13 68.5595 24.41 68.6795 24.7 68.6795L24.69 68.6895Z"
                  fill="#01522F"
                />
                <path
                  d="M68.42 21.6602H64.38V23.8902H68.42V21.6602Z"
                  fill="#01522F"
                />
                <path
                  d="M88.97 74.0098H86.94V76.4298H88.97V74.0098Z"
                  fill="#01522F"
                />
                <path
                  d="M88.97 79.9492H86.94V82.3692H88.97V79.9492Z"
                  fill="#01522F"
                />
                <path
                  d="M86.19 77.1797H83.77V79.2097H86.19V77.1797Z"
                  fill="#01522F"
                />
                <path
                  d="M92.14 77.1797H89.72V79.2097H92.14V77.1797Z"
                  fill="#01522F"
                />
                <path
                  d="M28.08 40.0605H26.05V42.4805H28.08V40.0605Z"
                  fill="#01522F"
                />
                <path
                  d="M28.08 46.0098H26.05V48.4298H28.08V46.0098Z"
                  fill="#01522F"
                />
                <path
                  d="M25.3 43.2305H22.88V45.2605H25.3V43.2305Z"
                  fill="#01522F"
                />
                <path
                  d="M31.25 43.2305H28.83V45.2605H31.25V43.2305Z"
                  fill="#01522F"
                />
              </g>
              <defs>
                <clipPath id="clip0_1610_4065">
                  <rect width="112.93" height="112.93" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typography
              className="work"
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 400,
                lineHeight: "28.8px",
                textAlign: "center",
              }}
            >
              Review Jobs
            </Typography>
            <Box
              sx={{
                width: mobileView ? "23%" : "152px",
                height: mobileView ? "0.1%" : "5px",
                backgroundColor: "#77C7A2",
              }}
            />
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              People looking for services submit job requests with details about
              the job.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: mobileView ? "100%" : "25%",
              gap: "1rem",
            }}
          >
            <svg
              width={mobileView ? "65%" : "113px"}
              height={mobileView ? "15%" : "113px"}
              viewBox="0 0 113 113"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1610_4043)">
                <path
                  d="M56.46 112.92C87.642 112.92 112.92 87.642 112.92 56.46C112.92 25.278 87.642 0 56.46 0C25.278 0 0 25.278 0 56.46C0 87.642 25.278 112.92 56.46 112.92Z"
                  fill="#FCF2E7"
                />
                <path
                  d="M63.2499 93.0202C78.3991 93.0202 90.6799 80.7393 90.6799 65.5902C90.6799 50.441 78.3991 38.1602 63.2499 38.1602C48.1008 38.1602 35.8199 50.441 35.8199 65.5902C35.8199 80.7393 48.1008 93.0202 63.2499 93.0202Z"
                  fill="#77C7A2"
                />
                <path
                  d="M72.45 22.7802C72.16 22.7802 71.88 22.6602 71.68 22.4602C71.48 22.2602 71.36 21.9802 71.36 21.6902C71.36 21.4002 71.48 21.1202 71.68 20.9202C71.73 20.8702 71.78 20.8202 71.84 20.7802C71.9 20.7402 71.96 20.7102 72.03 20.6802C72.1 20.6502 72.16 20.6302 72.24 20.6202C72.38 20.5902 72.52 20.5902 72.66 20.6202C72.73 20.6302 72.8 20.6602 72.86 20.6802C72.93 20.7102 72.99 20.7402 73.05 20.7802C73.11 20.8202 73.17 20.8602 73.21 20.9202C73.41 21.1202 73.53 21.4002 73.53 21.6902C73.53 21.7602 73.53 21.8302 73.51 21.9002C73.5 21.9702 73.48 22.0402 73.45 22.1002C73.42 22.1702 73.39 22.2302 73.35 22.2902C73.31 22.3502 73.26 22.4102 73.21 22.4502C73.01 22.6502 72.73 22.7702 72.44 22.7702L72.45 22.7802Z"
                  fill="#01522F"
                />
                <path
                  d="M26.28 41.4295C26.21 41.4295 26.14 41.4295 26.07 41.4095C26 41.3995 25.93 41.3695 25.87 41.3495C25.8 41.3195 25.74 41.2895 25.68 41.2495C25.62 41.2095 25.56 41.1695 25.51 41.1195C25.46 41.0695 25.4099 41.0095 25.3799 40.9495C25.3399 40.8895 25.31 40.8295 25.28 40.7595C25.25 40.6895 25.2299 40.6295 25.2199 40.5595C25.2099 40.4895 25.2 40.4195 25.2 40.3495C25.2 40.2795 25.1999 40.2095 25.2199 40.1395C25.2299 40.0695 25.26 39.9995 25.28 39.9395C25.31 39.8695 25.3399 39.8095 25.3799 39.7495C25.4199 39.6895 25.47 39.6295 25.52 39.5795C25.77 39.3295 26.15 39.2095 26.5 39.2795C26.57 39.2895 26.64 39.3195 26.7 39.3395C26.77 39.3695 26.8299 39.3995 26.8899 39.4395C26.9499 39.4795 27.0099 39.5195 27.0599 39.5695C27.1099 39.6195 27.16 39.6795 27.19 39.7395C27.23 39.7995 27.26 39.8595 27.29 39.9295C27.32 39.9995 27.34 40.0595 27.35 40.1295C27.36 40.1995 27.37 40.2695 27.37 40.3395C27.37 40.4095 27.37 40.4795 27.35 40.5495C27.34 40.6195 27.31 40.6895 27.29 40.7495C27.26 40.8195 27.23 40.8795 27.19 40.9395C27.15 40.9995 27.1099 41.0595 27.0599 41.1095C27.0099 41.1595 26.9499 41.2095 26.8899 41.2395C26.8299 41.2795 26.77 41.3095 26.7 41.3395C26.63 41.3695 26.57 41.3895 26.5 41.3995C26.43 41.4095 26.36 41.4195 26.29 41.4195L26.28 41.4295Z"
                  fill="#01522F"
                />
                <path
                  d="M83.13 76.1895C82.84 76.1895 82.56 76.0695 82.36 75.8695C82.16 75.6695 82.04 75.3895 82.04 75.0995C82.04 74.8095 82.16 74.5295 82.36 74.3295C82.41 74.2795 82.47 74.2295 82.53 74.1895C82.59 74.1495 82.65 74.1195 82.72 74.0895C82.79 74.0595 82.85 74.0395 82.92 74.0295C83.27 73.9595 83.65 74.0795 83.9 74.3295C83.95 74.3795 84 74.4395 84.03 74.4895C84.07 74.5495 84.1 74.6095 84.13 74.6795C84.16 74.7495 84.18 74.8095 84.19 74.8795C84.2 74.9495 84.21 75.0195 84.21 75.0895C84.21 75.3795 84.09 75.6595 83.89 75.8595C83.69 76.0595 83.41 76.1795 83.12 76.1795L83.13 76.1895Z"
                  fill="#01522F"
                />
                <path
                  d="M68.64 87.4707H64.6V89.7007H68.64V87.4707Z"
                  fill="#01522F"
                />
                <path
                  d="M84.45 50.541H80.41V52.771H84.45V50.541Z"
                  fill="#01522F"
                />
                <path
                  d="M24.29 56.3301H20.25V58.5601H24.29V56.3301Z"
                  fill="#01522F"
                />
                <path
                  d="M32.06 85.2115C31.54 85.2115 31.04 85.0015 30.66 84.6315C30.27 84.2415 30.04 83.6915 30.04 83.1315V29.2215C30.04 28.0715 30.94 27.1415 32.05 27.1315L34.92 27.1115L34.94 29.3915L32.33 29.4115V82.9215L72.82 82.7715V29.2615H70.38V26.9915H73.08C73.61 26.9715 74.11 27.1815 74.49 27.5615C74.88 27.9515 75.11 28.5015 75.11 29.0615V82.9615C75.11 84.1115 74.21 85.0415 73.1 85.0515L32.08 85.2015L32.06 85.2115Z"
                  fill="#01522F"
                />
                <path
                  d="M60.54 36.9316H44.92V39.2116H60.54V36.9316Z"
                  fill="#01522F"
                />
                <path
                  d="M64.57 43.1113H40.88V45.3913H64.57V43.1113Z"
                  fill="#01522F"
                />
                <path
                  d="M64.57 49.291H40.88V51.571H64.57V49.291Z"
                  fill="#01522F"
                />
                <path
                  d="M64.57 55.4707H40.88V57.7507H64.57V55.4707Z"
                  fill="#01522F"
                />
                <path
                  d="M52.19 73.0006C52.02 73.0006 51.85 72.9806 51.68 72.9306C49.97 72.4906 50.09 71.2506 50.13 71.0106C50.16 70.8606 50.19 70.6306 50.39 70.3306L46.25 72.8106C45.81 73.0706 45.25 73.0106 44.88 72.6606C44.51 72.3106 44.41 71.7606 44.65 71.3006C45.45 69.7706 46.15 68.0906 46.39 67.1906C46.21 67.3206 46 67.4806 45.79 67.7006L40.85 72.6306C40.4 73.0806 39.68 73.0706 39.24 72.6306C38.79 72.1806 38.8 71.4606 39.24 71.0206L44.18 66.0906C44.75 65.5206 46.23 64.2406 47.58 64.7306C47.9 64.8506 48.66 65.2606 48.76 66.4706C48.81 67.0906 48.56 68.0206 48.2 68.9806L51.76 66.8506C52.16 66.5606 52.67 66.4906 53.14 66.6506C53.65 66.8206 54.02 67.2406 54.14 67.7706C54.14 67.8006 54.15 67.8306 54.16 67.8606C54.16 67.8706 54.16 67.8906 54.16 67.9106C55.03 67.5406 56.95 66.8006 57.91 66.8806C58.76 66.9506 59.15 67.5806 59.15 68.1406C59.15 68.1906 59.15 68.2406 59.14 68.3006L58.94 69.7706C59.76 69.5106 60.91 69.0906 62.42 68.4006C62.9 68.1806 63.47 68.3206 63.79 68.7406C64.03 69.0506 64.09 69.4606 63.97 69.8206C63.97 69.8206 63.98 69.8206 63.99 69.8206C64.59 69.6406 65.23 69.9906 65.41 70.5906C65.59 71.1906 65.24 71.8306 64.64 72.0106C64.33 72.1006 62.76 72.5606 62.01 72.6306C61.48 72.6806 61 72.4306 60.76 71.9806C60.7 71.8706 60.65 71.7506 60.62 71.6306C58.78 72.3006 57.85 72.4306 57.72 72.4506C57.37 72.4906 57.02 72.3706 56.77 72.1206C56.52 71.8706 56.4 71.5106 56.45 71.1606L56.69 69.4106C55.97 69.6406 55.06 70.0106 54.24 70.3906C54.16 71.2506 53.92 72.0806 53.38 72.5706C53.04 72.8706 52.63 73.0306 52.19 73.0306V73.0006Z"
                  fill="#01522F"
                />
                <path
                  d="M66.5901 33.0111H38.7901C37.6001 33.0111 36.7001 32.1411 36.7001 30.9811V30.8711C36.9601 28.2411 39.1401 26.2511 41.7901 26.2511H46.7701C46.9601 25.2711 47.4601 24.3411 48.2201 23.5811C49.4601 22.3411 51.2701 21.6211 53.1901 21.6211C56.2901 21.6211 58.9601 23.6711 59.5701 26.3011C60.2701 26.3011 61.5001 26.3011 63.6801 26.2811C63.6901 26.2811 63.7101 26.2811 63.7201 26.2811C66.2801 26.2811 68.4501 28.1911 68.7801 30.7311L68.8001 30.9011V30.9711C68.8001 32.0911 67.8101 33.0011 66.5901 33.0011V33.0111ZM39.0401 30.7311H66.4601C66.1501 29.4711 65.0101 28.5711 63.6901 28.5711C62.5001 28.5711 61.2201 28.5911 60.2401 28.5911C59.7401 28.5911 59.3201 28.5911 59.0201 28.5911C58.4201 28.5911 58.0901 28.5811 57.7501 28.2411L57.4101 27.9111V27.4311C57.4101 25.5611 55.4401 23.9211 53.1901 23.9211C51.8701 23.9211 50.6501 24.3911 49.8401 25.2011C49.4401 25.6011 48.9701 26.2611 48.9601 27.1711C48.9601 27.1911 48.9601 27.2011 48.9601 27.2011L49.2001 28.5411H47.8401H41.7801C40.4401 28.5411 39.3201 29.4611 39.0301 30.7311H39.0401Z"
                  fill="#01522F"
                />
                <path
                  d="M53.2001 29.9404C51.6701 29.9404 50.4301 28.7004 50.4301 27.1704C50.4301 25.6404 51.6701 24.4004 53.2001 24.4004C54.7301 24.4004 55.9701 25.6404 55.9701 27.1704C55.9701 28.7004 54.7301 29.9404 53.2001 29.9404ZM53.2001 26.6704C52.9301 26.6704 52.7101 26.8904 52.7101 27.1604C52.7101 27.4304 52.9301 27.6504 53.2001 27.6504C53.4701 27.6504 53.6901 27.4304 53.6901 27.1604C53.6901 26.8904 53.4701 26.6704 53.2001 26.6704Z"
                  fill="#01522F"
                />
              </g>
              <defs>
                <clipPath id="clip0_1610_4043">
                  <rect width="112.93" height="112.93" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typography
              className="work"
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 400,
                lineHeight: "28.8px",
                textAlign: "center",
              }}
            >
              Submit Bids
            </Typography>
            <Box
              sx={{
                width: mobileView ? "23%" : "152px",
                height: mobileView ? "0.1%" : "5px",
                backgroundColor: "#77C7A2",
              }}
            />
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              You set your price and choose a time and date that works for
              everyone.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: mobileView ? "100%" : "25%",
              gap: "1rem",
            }}
          >
            <svg
              width={mobileView ? "65%" : "113px"}
              height={mobileView ? "15%" : "113px"}
              viewBox="0 0 113 113"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1595_3890)">
                <path
                  d="M56.46 112.92C87.642 112.92 112.92 87.642 112.92 56.46C112.92 25.278 87.642 0 56.46 0C25.278 0 0 25.278 0 56.46C0 87.642 25.278 112.92 56.46 112.92Z"
                  fill="#FCF2E7"
                />
                <path
                  d="M56.71 69.3818C56.39 69.3818 56.13 69.1218 56.13 68.8018V66.4218H55.42C53.03 66.4218 51.08 64.7018 51.08 62.5918V60.1018C51.08 59.7818 51.34 59.5218 51.66 59.5218H53.92C54.24 59.5218 54.5 59.7818 54.5 60.1018V62.5918C54.52 62.6818 54.82 62.9918 55.41 62.9918H59.45C60.04 62.9918 60.35 62.6818 60.37 62.5918V60.7518C60.37 59.7318 59.52 58.7918 58.19 58.3618L56.19 57.7018C53.44 56.7918 51.66 54.5818 51.66 52.0518V49.8818C51.66 47.7718 53.61 46.0518 56 46.0518H56.12V43.6718C56.12 43.3518 56.38 43.0918 56.7 43.0918H58.96C59.28 43.0918 59.54 43.3518 59.54 43.6718V46.0518C61.89 46.1018 63.78 47.7918 63.78 49.8818V52.2118C63.78 52.5318 63.52 52.7918 63.2 52.7918H60.94C60.62 52.7918 60.36 52.5318 60.36 52.2118V49.8818C60.34 49.7918 60.04 49.4818 59.45 49.4818H56C55.41 49.4818 55.1 49.7918 55.08 49.8818V52.0518C55.08 53.0718 55.93 54.0118 57.26 54.4418L59.26 55.1018C62.01 56.0118 63.79 58.2218 63.79 60.7518V62.6018C63.79 64.6818 61.9 66.3818 59.55 66.4318V68.8118C59.55 69.1318 59.29 69.3918 58.97 69.3918H56.71V69.3818Z"
                  fill="#77C7A2"
                />
                <path
                  d="M23.91 44.8713C23.84 44.8713 23.78 44.8713 23.71 44.8513C23.64 44.8413 23.58 44.8213 23.52 44.7913C23.46 44.7613 23.4 44.7313 23.34 44.6913C23.28 44.6513 23.23 44.6113 23.18 44.5613C23.13 44.5113 23.09 44.4613 23.05 44.4013C23.01 44.3413 22.98 44.2813 22.96 44.2213C22.93 44.1613 22.91 44.0913 22.9 44.0313C22.89 43.9613 22.88 43.9013 22.88 43.8313C22.88 43.7613 22.88 43.6913 22.9 43.6313C22.91 43.5613 22.93 43.5013 22.96 43.4413C22.98 43.3813 23.02 43.3213 23.05 43.2613C23.09 43.2013 23.13 43.1513 23.18 43.1013C23.23 43.0513 23.28 43.0113 23.34 42.9713C23.4 42.9313 23.46 42.9013 23.52 42.8813C23.58 42.8513 23.65 42.8313 23.71 42.8213C23.84 42.7913 23.98 42.7913 24.11 42.8213C24.18 42.8313 24.24 42.8513 24.3 42.8813C24.36 42.9113 24.42 42.9413 24.48 42.9713C24.54 43.0113 24.59 43.0513 24.64 43.1013C24.83 43.2913 24.94 43.5613 24.94 43.8313C24.94 44.1013 24.83 44.3713 24.64 44.5613C24.59 44.6113 24.54 44.6513 24.48 44.6913C24.42 44.7313 24.36 44.7613 24.3 44.7913C24.24 44.8213 24.17 44.8413 24.11 44.8513C24.04 44.8613 23.97 44.8713 23.91 44.8713Z"
                  fill="#01522F"
                />
                <path
                  d="M61.37 74.6311C61.3 74.6311 61.24 74.6311 61.17 74.6111C61.1 74.6011 61.04 74.5811 60.98 74.5511C60.92 74.5211 60.86 74.4911 60.8 74.4611C60.74 74.4211 60.69 74.3811 60.64 74.3311C60.59 74.2811 60.55 74.2311 60.51 74.1711C60.47 74.1111 60.44 74.0511 60.42 73.9911C60.4 73.9311 60.37 73.8611 60.36 73.8011C60.35 73.7311 60.34 73.6711 60.34 73.6011C60.34 73.5311 60.34 73.4611 60.36 73.4011C60.37 73.3311 60.39 73.2711 60.42 73.2111C60.45 73.1511 60.48 73.0911 60.51 73.0311C60.55 72.9711 60.59 72.9211 60.64 72.8711C60.69 72.8211 60.74 72.7811 60.8 72.7411C60.86 72.7011 60.92 72.6711 60.98 72.6511C61.04 72.6211 61.11 72.6011 61.17 72.5911C61.5 72.5211 61.86 72.6311 62.1 72.8711C62.15 72.9211 62.19 72.9711 62.23 73.0311C62.27 73.0911 62.3 73.1511 62.33 73.2111C62.36 73.2711 62.38 73.3411 62.39 73.4011C62.4 73.4711 62.41 73.5311 62.41 73.6011C62.41 73.6711 62.41 73.7411 62.39 73.8011C62.38 73.8711 62.36 73.9311 62.33 73.9911C62.3 74.0511 62.27 74.1111 62.23 74.1711C62.19 74.2311 62.15 74.2811 62.1 74.3311C61.91 74.5211 61.64 74.6311 61.37 74.6311Z"
                  fill="#01522F"
                />
                <path
                  d="M81.2101 28.9709C81.1401 28.9709 81.0701 28.9709 81.0101 28.9509C80.9401 28.9409 80.8801 28.9209 80.8201 28.8909C80.7601 28.8609 80.7001 28.8309 80.6401 28.8009C80.5801 28.7609 80.5301 28.7209 80.4801 28.6709C80.4301 28.6209 80.3901 28.5709 80.3501 28.5109C80.3101 28.4509 80.2801 28.3909 80.2601 28.3309C80.2301 28.2709 80.2101 28.2009 80.2001 28.1409C80.1901 28.0709 80.1801 28.0109 80.1801 27.9409C80.1801 27.8709 80.1801 27.8009 80.2001 27.7409C80.2101 27.6709 80.2301 27.6109 80.2601 27.5509C80.2801 27.4909 80.3201 27.4309 80.3501 27.3709C80.3901 27.3109 80.4301 27.2609 80.4801 27.2109C80.5301 27.1609 80.5801 27.1209 80.6401 27.0809C80.7001 27.0409 80.7601 27.0109 80.8201 26.9809C80.8801 26.9509 80.9501 26.9309 81.0101 26.9209C81.1401 26.8909 81.2801 26.8909 81.4101 26.9209C81.4801 26.9309 81.5401 26.9509 81.6001 26.9809C81.6601 27.0109 81.7201 27.0409 81.7801 27.0809C81.8401 27.1209 81.8901 27.1609 81.9401 27.2109C81.9901 27.2609 82.0301 27.3109 82.0701 27.3709C82.1101 27.4309 82.1401 27.4909 82.1601 27.5509C82.1901 27.6109 82.2101 27.6809 82.2201 27.7409C82.2301 27.8109 82.2401 27.8809 82.2401 27.9409C82.2401 28.0009 82.2401 28.0709 82.2201 28.1409C82.2101 28.2109 82.1901 28.2709 82.1601 28.3309C82.1301 28.3909 82.1001 28.4509 82.0701 28.5109C82.0301 28.5709 81.9901 28.6209 81.9401 28.6709C81.8901 28.7209 81.8401 28.7609 81.7801 28.8009C81.7201 28.8409 81.6601 28.8709 81.6001 28.8909C81.5401 28.9209 81.4701 28.9409 81.4101 28.9509C81.3401 28.9609 81.2801 28.9709 81.2101 28.9709Z"
                  fill="#01522F"
                />
                <path
                  d="M60 96.8616C59.73 96.8616 59.46 96.7516 59.27 96.5616C59.08 96.3716 58.97 96.1016 58.97 95.8316C58.97 95.7616 58.97 95.6916 58.99 95.6316C59 95.5616 59.02 95.5016 59.05 95.4416C59.08 95.3816 59.11 95.3216 59.15 95.2616C59.19 95.2016 59.23 95.1516 59.28 95.1016C59.33 95.0516 59.38 95.0116 59.44 94.9716C59.5 94.9316 59.56 94.9016 59.62 94.8716C59.68 94.8416 59.75 94.8216 59.81 94.8116C59.94 94.7816 60.08 94.7816 60.21 94.8116C60.28 94.8216 60.34 94.8416 60.4 94.8716C60.46 94.9016 60.52 94.9316 60.58 94.9716C60.64 95.0116 60.69 95.0516 60.74 95.1016C60.79 95.1516 60.83 95.2016 60.87 95.2616C60.91 95.3216 60.94 95.3816 60.96 95.4416C60.99 95.5016 61.01 95.5716 61.02 95.6316C61.03 95.7016 61.04 95.7616 61.04 95.8316C61.04 96.1016 60.93 96.3716 60.74 96.5616C60.69 96.6116 60.64 96.6516 60.58 96.6916C60.52 96.7316 60.46 96.7616 60.4 96.7916C60.34 96.8216 60.27 96.8416 60.21 96.8516C60.14 96.8616 60.08 96.8716 60.01 96.8716L60 96.8616Z"
                  fill="#01522F"
                />
                <path
                  d="M88.22 36.6309H84.4V38.7409H88.22V36.6309Z"
                  fill="#01522F"
                />
                <path
                  d="M34.86 83.4902H31.04V85.6002H34.86V83.4902Z"
                  fill="#01522F"
                />
                <path
                  d="M87.8801 89.3105H84.0601V91.4205H87.8801V89.3105Z"
                  fill="#01522F"
                />
                <path
                  d="M30.7601 29.4512H26.9401V31.5612H30.7601V29.4512Z"
                  fill="#01522F"
                />
                <path
                  d="M90.41 82.9918L89.43 85.0318L87.39 84.0518L76.44 78.7918C76.12 78.9518 75.68 79.1518 75.17 79.3618V76.8918C75.6 76.6918 75.87 76.5418 75.88 76.5418C76.2 76.3718 76.59 76.3518 76.91 76.5118L88.37 82.0118L90.41 82.9918Z"
                  fill="#01522F"
                />
                <path
                  d="M72.99 86.2517C72.99 87.3617 72.08 88.2717 70.97 88.2717H44.32C43.21 88.2717 42.3 87.3617 42.3 86.2517V43.0117H40.01V86.2517C40.01 88.6317 41.94 90.5617 44.32 90.5617H70.97C73.35 90.5617 75.28 88.6317 75.28 86.2517V73.2617H72.99V86.2517Z"
                  fill="#01522F"
                />
                <path
                  d="M70.96 25.1309H44.31C41.93 25.1309 40 27.0609 40 29.4409V36.7609H42.29V29.4409C42.29 28.3309 43.2 27.4209 44.31 27.4209H70.96C72.07 27.4209 72.98 28.3309 72.98 29.4409V45.0309H75.27V29.4409C75.27 27.0609 73.34 25.1309 70.96 25.1309Z"
                  fill="#01522F"
                />
                <path
                  d="M74.13 78.3105H41.15V80.6005H74.13V78.3105Z"
                  fill="#01522F"
                />
                <path
                  d="M73.72 31.9414H41.15V34.2314H73.72V31.9414Z"
                  fill="#01522F"
                />
                <path
                  d="M61.4599 28.7402H53.8199V31.0302H61.4599V28.7402Z"
                  fill="#01522F"
                />
                <path
                  d="M57.64 87.4809C55.84 87.4809 54.38 86.0209 54.38 84.2209C54.38 82.4209 55.84 80.9609 57.64 80.9609C59.44 80.9609 60.9 82.4209 60.9 84.2209C60.9 86.0209 59.44 87.4809 57.64 87.4809ZM57.64 83.2409C57.1 83.2409 56.67 83.6809 56.67 84.2109C56.67 84.7409 57.11 85.1809 57.64 85.1809C58.17 85.1809 58.61 84.7409 58.61 84.2109C58.61 83.6809 58.17 83.2409 57.64 83.2409Z"
                  fill="#01522F"
                />
                <path
                  d="M47.5 72.5108L47.41 71.2208C47.32 70.0108 46.72 68.9608 45.84 68.2508C45.87 68.2108 45.91 68.1808 45.94 68.1408C46.67 67.2908 47.03 66.2008 46.95 65.0808L46.85 63.7908C46.76 62.5808 46.16 61.5208 45.28 60.8208C46.05 59.9908 46.48 58.8608 46.39 57.6508L46.29 56.3608C46.2 55.1508 45.6 54.1008 44.72 53.3908C44.75 53.3508 44.79 53.3208 44.82 53.2808C45.55 52.4308 45.91 51.3408 45.83 50.2208L45.73 48.9308C45.56 46.6108 43.53 44.8708 41.22 45.0408L36.67 45.3808C34.35 45.5508 32.61 47.5808 32.78 49.8908L32.88 51.1808C32.96 52.2308 33.41 53.1508 34.1 53.8408C34.21 53.9508 34.32 54.0508 34.44 54.1508C34.41 54.1908 34.37 54.2208 34.34 54.2608C33.61 55.1108 33.25 56.2008 33.33 57.3208L33.43 58.6108C33.51 59.6308 33.93 60.5608 34.65 61.2708C34.72 61.3408 34.8 61.4208 34.88 61.4908C34.92 61.5208 34.96 61.5508 35 61.5908C34.23 62.4208 33.8 63.5508 33.89 64.7608L33.98 66.0508C34.06 67.1008 34.51 68.0208 35.2 68.7108C35.31 68.8208 35.42 68.9208 35.55 69.0208C35.52 69.0608 35.48 69.0908 35.45 69.1308C34.72 69.9808 34.36 71.0708 34.44 72.1908L34.54 73.4808C34.62 74.5308 35.07 75.4508 35.76 76.1408C36.6 76.9808 37.78 77.4608 39.05 77.3708L43.6 77.0308C45.92 76.8608 47.66 74.8308 47.49 72.5208L47.5 72.5108Z"
                  fill="#FCF2E7"
                />
                <path
                  d="M35.22 68.7001C34.53 68.0101 34.08 67.0801 34 66.0401L33.91 64.7501C33.74 62.4301 35.48 60.4101 37.8 60.2401L42.35 59.9001C44.67 59.7301 46.69 61.4701 46.86 63.7901L46.96 65.0801C47.04 66.2001 46.68 67.2901 45.95 68.1401C45.22 68.9901 44.19 69.5101 43.07 69.5901L38.52 69.9301C37.25 70.0201 36.07 69.5401 35.23 68.7001H35.22ZM44.04 62.7301C44.04 62.7301 43.97 62.6601 43.93 62.6301C43.54 62.2901 43.03 62.1201 42.51 62.1601L37.96 62.5001C36.89 62.5801 36.08 63.5201 36.16 64.5901L36.25 65.8801C36.33 66.9501 37.27 67.7601 38.34 67.6801L42.89 67.3401C43.41 67.3001 43.88 67.0601 44.22 66.6701C44.56 66.2801 44.73 65.7701 44.69 65.2501L44.59 63.9601C44.56 63.4901 44.36 63.0601 44.03 62.7301H44.04Z"
                  fill="#01522F"
                />
                <path
                  d="M35.7801 76.1318C35.0901 75.4418 34.6401 74.5118 34.5601 73.4718L34.4601 72.1818C34.3801 71.0618 34.7401 69.9718 35.4701 69.1218C36.2001 68.2718 37.2301 67.7518 38.3501 67.6718L42.9001 67.3318C45.2201 67.1618 47.2401 68.9018 47.4101 71.2218L47.5001 72.5118C47.6701 74.8318 45.9301 76.8518 43.6101 77.0218L39.0601 77.3618C37.7901 77.4518 36.6101 76.9718 35.7701 76.1318H35.7801ZM44.5901 70.1618C44.2001 69.7718 43.6501 69.5518 43.0701 69.5918L38.5201 69.9318C38.0001 69.9718 37.5301 70.2118 37.1901 70.6018C36.8501 70.9918 36.6801 71.5018 36.7201 72.0218L36.8201 73.3118C36.8601 73.8318 37.1001 74.3018 37.4901 74.6418C37.8801 74.9818 38.3901 75.1518 38.9101 75.1118L43.4601 74.7718C44.5301 74.6918 45.3401 73.7518 45.2601 72.6818L45.1601 71.3918C45.1201 70.9118 44.9101 70.4818 44.5901 70.1618Z"
                  fill="#01522F"
                />
                <path
                  d="M34.12 53.8408C33.43 53.1508 32.98 52.2208 32.9 51.1808L32.8 49.8908C32.63 47.5708 34.37 45.5508 36.69 45.3808L41.24 45.0408C43.56 44.8708 45.58 46.6108 45.75 48.9308L45.85 50.2208C45.93 51.3408 45.57 52.4308 44.84 53.2808C44.11 54.1308 43.08 54.6508 41.96 54.7308L37.41 55.0708C36.14 55.1608 34.96 54.6808 34.12 53.8408ZM42.93 47.8608C42.93 47.8608 42.86 47.7908 42.82 47.7608C42.43 47.4208 41.92 47.2508 41.4 47.2908L36.85 47.6308C35.78 47.7108 34.97 48.6508 35.05 49.7208L35.14 51.0108C35.18 51.5308 35.42 52.0108 35.81 52.3408C36.2 52.6808 36.71 52.8508 37.23 52.8108L41.78 52.4708C42.3 52.4308 42.77 52.1908 43.11 51.8008C43.45 51.4108 43.62 50.9008 43.58 50.3808L43.48 49.0908C43.45 48.6208 43.25 48.1908 42.92 47.8608H42.93Z"
                  fill="#01522F"
                />
                <path
                  d="M34.6701 61.2705C33.9601 60.5605 33.5301 59.6205 33.4501 58.6105L33.3501 57.3205C33.2701 56.2005 33.6301 55.1104 34.3601 54.2604C35.0901 53.4104 36.1201 52.8905 37.2401 52.8105L41.7901 52.4705C44.1101 52.3005 46.1301 54.0405 46.3001 56.3605L46.4001 57.6505C46.5701 59.9705 44.8301 61.9905 42.5101 62.1605L37.9601 62.5005C36.8401 62.5805 35.7501 62.2205 34.9001 61.4905C34.8201 61.4205 34.7401 61.3505 34.6701 61.2705ZM43.4801 55.3005C43.0901 54.9105 42.5401 54.6905 41.9601 54.7305L37.4101 55.0705C36.8901 55.1105 36.4201 55.3505 36.0801 55.7405C35.7401 56.1305 35.5701 56.6405 35.6101 57.1605L35.7101 58.4505C35.7501 58.9705 35.9801 59.4405 36.3801 59.7805C36.7701 60.1205 37.2801 60.2905 37.8001 60.2505L42.3501 59.9105C43.4201 59.8305 44.2301 58.8905 44.1501 57.8205L44.0501 56.5305C44.0101 56.0505 43.8001 55.6205 43.4801 55.3005Z"
                  fill="#01522F"
                />
                <path
                  d="M97.33 63.1804L97.11 63.6304L96.35 65.2204L80.5 58.1504C80.19 58.0104 79.95 57.7404 79.87 57.4104L77.76 49.6404C77.37 48.2304 76.39 47.0504 75.06 46.4304L66.18 42.6204C64.91 46.3104 66.64 50.4104 70.22 52.0504C70.25 52.0604 70.28 52.0804 70.31 52.1004L71.99 52.9904C72.25 53.1404 72.44 53.3804 72.52 53.6704L73.68 57.8904C73.85 58.4904 73.49 59.1204 72.89 59.2804C72.29 59.4504 71.67 59.1104 71.5 58.4904L70.46 54.7204L69.22 54.0904C66.79 52.9604 65.02 50.9604 64.13 48.6204C63.29 46.4104 63.24 43.8904 64.16 41.5304L64.49 40.6704C64.6 40.3804 64.83 40.1404 65.13 40.0304C65.23 39.9904 65.34 39.9604 65.45 39.9504C65.65 39.9304 65.85 39.9704 66.03 40.0504L76.02 44.3704C77.95 45.2804 79.38 46.9804 79.94 49.0404L81.91 56.2904L97.33 63.1704V63.1804Z"
                  fill="#01522F"
                />
                <path
                  d="M78.43 79.7414C76.69 78.9214 75.31 77.8014 74.33 76.4014C72.63 73.9914 72.63 71.5714 72.62 68.5114C72.62 66.7114 72.61 64.6814 72.26 62.2114C71.96 60.0714 71.45 57.9614 70.75 55.9414L72.91 55.1914C73.66 57.3514 74.2 59.6114 74.52 61.8914C74.89 64.5114 74.89 66.6314 74.9 68.5014C74.9 71.3614 74.91 73.2614 76.19 75.0714C76.95 76.1414 78.02 77.0114 79.4 77.6614L78.43 79.7314V79.7414Z"
                  fill="#01522F"
                />
              </g>
              <defs>
                <clipPath id="clip0_1595_3890">
                  <rect width="112.93" height="112.93" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typography
              className="work"
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 400,
                lineHeight: "28.8px",
                textAlign: "center",
              }}
            >
              Get Paid
            </Typography>
            <Box
              sx={{
                width: mobileView ? "23%" : "152px",
                height: mobileView ? "0.1%" : "5px",
                backgroundColor: "#FFFFFF",
              }}
            />
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              Payments are processed right inside of FixDen so you can move onto
              the next job.
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: "2rem",
            // position: "absolute",
            top: mobileView ? "37%" : "1336px",
            width: "100%",
            height: mobileView ? "fit-content" : "304px",

            backgroundImage: `url(${require("../../images/gradient.png")})`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: mobileView ? "column" : "row",
              height: "100%",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: mobileView ? "100%" : "50%",
              }}
            >
              <Box
                sx={{
                  // position: "absolute",
                  width: mobileView ? "auto" : "250px",
                  height: mobileView ? "auto" : "32px",
                }}
              >
                <Typography
                  className="work"
                  style={{
                    color: "#77C7A2",
                    fontFamily: "Brockmann",
                    fontSize: 24,
                    fontWeight: 600,
                    lineHeight: "28.8px",
                    textAlign: "center",
                  }}
                >
                  Features
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "2rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 20L11.794 20.7211C11.9286 20.7596 12.0714 20.7596 12.206 20.7211L12 20ZM10.8022 19.6578L10.5962 20.3789L10.8022 19.6578ZM13.1978 19.6578L13.4038 20.3789L13.1978 19.6578ZM17.8316 5.2713L18.1707 4.60235L17.8316 5.2713ZM6.16838 5.2713L6.50751 5.94024L6.16838 5.2713ZM13.5 10.25C13.9142 10.25 14.25 9.91421 14.25 9.5C14.25 9.08579 13.9142 8.75 13.5 8.75V10.25ZM10.5 13.75C10.0858 13.75 9.75 14.0858 9.75 14.5C9.75 14.9142 10.0858 15.25 10.5 15.25V13.75ZM12.75 8.5C12.75 8.08579 12.4142 7.75 12 7.75C11.5858 7.75 11.25 8.08579 11.25 8.5H12.75ZM11.25 9C11.25 9.41421 11.5858 9.75 12 9.75C12.4142 9.75 12.75 9.41421 12.75 9H11.25ZM12.75 15C12.75 14.5858 12.4142 14.25 12 14.25C11.5858 14.25 11.25 14.5858 11.25 15H12.75ZM11.25 15.5C11.25 15.9142 11.5858 16.25 12 16.25C12.4142 16.25 12.75 15.9142 12.75 15.5H11.25ZM18.25 7.3798V11.9656H19.75V7.3798H18.25ZM5.75 11.9656V7.3798H4.25V11.9656H5.75ZM12.9917 18.9366L11.794 19.2789L12.206 20.7211L13.4038 20.3789L12.9917 18.9366ZM12.206 19.2789L11.0083 18.9366L10.5962 20.3789L11.794 20.7211L12.206 19.2789ZM6.50751 5.94024C7.54292 5.41534 9.37137 4.75 12 4.75V3.25C9.10842 3.25 7.04912 3.98393 5.82925 4.60235L6.50751 5.94024ZM12 4.75C14.6286 4.75 16.4571 5.41534 17.4925 5.94024L18.1707 4.60235C16.9509 3.98393 14.8916 3.25 12 3.25V4.75ZM4.25 11.9656C4.25 15.8723 6.8398 19.3057 10.5962 20.3789L11.0083 18.9366C7.89584 18.0474 5.75 15.2026 5.75 11.9656H4.25ZM18.25 11.9656C18.25 15.2026 16.1042 18.0474 12.9917 18.9366L13.4038 20.3789C17.1602 19.3057 19.75 15.8723 19.75 11.9656H18.25ZM19.75 7.3798C19.75 6.30153 19.2682 5.1587 18.1707 4.60235L17.4925 5.94024C17.9573 6.17589 18.25 6.70653 18.25 7.3798H19.75ZM5.75 7.3798C5.75 6.70653 6.04268 6.17589 6.50751 5.94024L5.82925 4.60235C4.73182 5.1587 4.25 6.30153 4.25 7.3798H5.75ZM11.25 10.25H13.5V8.75H11.25V10.25ZM12.75 11.25H11.25V12.75H12.75V11.25ZM12.75 13.75H10.5V15.25H12.75V13.75ZM13.25 13.25C13.25 13.5261 13.0261 13.75 12.75 13.75V15.25C13.8546 15.25 14.75 14.3546 14.75 13.25H13.25ZM11.25 11.25C10.9739 11.25 10.75 11.0261 10.75 10.75H9.25C9.25 11.8546 10.1454 12.75 11.25 12.75V11.25ZM12.75 12.75C13.0261 12.75 13.25 12.9739 13.25 13.25H14.75C14.75 12.1454 13.8546 11.25 12.75 11.25V12.75ZM11.25 8.75C10.1454 8.75 9.25 9.64543 9.25 10.75H10.75C10.75 10.4739 10.9739 10.25 11.25 10.25V8.75ZM11.25 8.5V9H12.75V8.5H11.25ZM11.25 15V15.5H12.75V15H11.25Z"
                          fill="#77C7A2"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "180%" : "36.8px",
                      }}
                    >
                      Transparent Pricing
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 20L16.1333 16.1333M18.2222 11.1111C18.2222 15.0385 15.0385 18.2222 11.1111 18.2222C7.18375 18.2222 4 15.0385 4 11.1111C4 7.18375 7.18375 4 11.1111 4C15.0385 4 18.2222 7.18375 18.2222 11.1111Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "420%" : "36.8px",
                      }}
                    >
                      Convenient Search
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 14C16 14.2761 15.7761 14.5 15.5 14.5C15.2239 14.5 15 14.2761 15 14C15 13.7239 15.2239 13.5 15.5 13.5C15.7761 13.5 16 13.7239 16 14Z"
                          fill="#77C7A2"
                        />
                        <path
                          d="M4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75V9.25ZM7 6.75H17V5.25H7V6.75ZM19.25 9V15H20.75V9H19.25ZM17 17.25H7V18.75H17V17.25ZM4.75 15V9H3.25V15H4.75ZM7 17.25C5.75736 17.25 4.75 16.2426 4.75 15H3.25C3.25 17.0711 4.92893 18.75 7 18.75V17.25ZM19.25 15C19.25 16.2426 18.2426 17.25 17 17.25V18.75C19.0711 18.75 20.75 17.0711 20.75 15H19.25ZM17 6.75C18.2426 6.75 19.25 7.75736 19.25 9H20.75C20.75 6.92893 19.0711 5.25 17 5.25V6.75ZM7 5.25C4.92893 5.25 3.25 6.92893 3.25 9H4.75C4.75 7.75736 5.75736 6.75 7 6.75V5.25ZM4 10.75H20V9.25H4V10.75ZM15.25 14C15.25 13.8619 15.3619 13.75 15.5 13.75V15.25C16.1904 15.25 16.75 14.6904 16.75 14H15.25ZM15.5 13.75C15.6381 13.75 15.75 13.8619 15.75 14H14.25C14.25 14.6904 14.8096 15.25 15.5 15.25V13.75ZM15.75 14C15.75 14.1381 15.6381 14.25 15.5 14.25V12.75C14.8096 12.75 14.25 13.3096 14.25 14H15.75ZM15.5 14.25C15.3619 14.25 15.25 14.1381 15.25 14H16.75C16.75 13.3096 16.1904 12.75 15.5 12.75V14.25Z"
                          fill="#77C7A2"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "280%" : "36.8px",
                      }}
                    >
                      Payment Processing
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 12L10.2929 13.2929C10.6834 13.6834 11.3166 13.6834 11.7071 13.2929L15 10M20 12C20.0032 13.2422 19.713 14.4676 19.1529 15.5765C18.4889 16.9052 17.468 18.0227 16.2046 18.804C14.9413 19.5853 13.4854 19.9994 12 20C10.9775 20.0026 9.96645 19.8065 9.0224 19.4247C8.62628 19.2645 8.19625 19.1914 7.77496 19.2628L5.72923 19.4807C5.03226 19.5549 4.44455 18.9671 4.51894 18.2701L4.73722 16.225C4.80858 15.8038 4.73551 15.3737 4.57531 14.9776C4.19352 14.0336 3.99736 13.0225 4.00003 12C4.0006 10.5146 4.41472 9.05869 5.19599 7.79536C5.97727 6.53202 7.09484 5.51114 8.42354 4.84708C9.53235 4.28702 10.7578 3.99679 12 4.00003H12.4706C14.4323 4.10825 16.2852 4.93627 17.6745 6.32553C19.0637 7.7148 19.8917 9.56768 20 11.5294V12Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "480%" : "36.8px",
                      }}
                    >
                      Messaging
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        // width="24"
                        // height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.7913 4.29304L19.7071 7.20882C20.0974 7.59909 20.0974 8.23277 19.7071 8.62303L18.2492 10.0809L13.9192 5.75094L15.3771 4.29304C15.7674 3.90278 16.4011 3.90278 16.7913 4.29304Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.2492 10.08L17.6362 15.5971C17.5764 16.1353 17.1126 16.5325 16.5718 16.5033C14.7602 16.4054 10.6816 16.3655 7.04099 17.612C6.63601 17.7506 6.24856 17.3632 6.38722 16.9582C7.63374 13.3176 7.59376 9.23896 7.49589 7.42738C7.46668 6.88664 7.86389 6.42281 8.4021 6.36301L13.9192 5.75L18.2492 10.08Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.8367 12.6946C13.6822 12.6946 14.3676 12.0092 14.3676 11.1637C14.3676 10.3182 13.6822 9.63281 12.8367 9.63281C11.9912 9.63281 11.3058 10.3182 11.3058 11.1637C11.3058 12.0092 11.9912 12.6946 12.8367 12.6946Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12 20C7.58172 20 4 16.4183 4 12"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "180%" : "36.8px",
                      }}
                    >
                      Legal Contracts
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.00369 4C9.00369 3.58579 8.6679 3.25 8.25369 3.25C7.83948 3.25 7.50369 3.58579 7.50369 4H9.00369ZM7.50369 6.81583C7.50369 7.23004 7.83948 7.56583 8.25369 7.56583C8.6679 7.56583 9.00369 7.23004 9.00369 6.81583H7.50369ZM14.972 6.81583C14.972 7.23004 15.3078 7.56583 15.722 7.56583C16.1362 7.56583 16.472 7.23004 16.472 6.81583H14.972ZM16.472 4.00003C16.472 3.58581 16.1362 3.25003 15.722 3.25003C15.3078 3.25003 14.972 3.58581 14.972 4.00003H16.472ZM4.51954 17.1994L5.26954 17.1994L4.51954 17.1994ZM4.51954 7.86398L5.26954 7.86398V7.86398H4.51954ZM7.50369 4V6.81583H9.00369V4H7.50369ZM15.722 5.81336H16.6556V4.31336H15.722V5.81336ZM14.972 5.06336V6.81583H16.472V5.06336H14.972ZM16.472 5.06336V4.00003H14.972V5.06336H16.472ZM3.76954 17.1994C3.76953 19.1603 5.3592 20.75 7.32015 20.75V19.25C6.18763 19.25 5.26953 18.3319 5.26954 17.1994L3.76954 17.1994ZM18.7062 17.1994C18.7062 18.3319 17.7881 19.25 16.6556 19.25V20.75C18.6165 20.75 20.2062 19.1603 20.2062 17.1994H18.7062ZM20.2062 7.86398C20.2062 5.90303 18.6165 4.31336 16.6556 4.31336V5.81336C17.7881 5.81336 18.7062 6.73146 18.7062 7.86398H20.2062ZM5.26954 7.86398C5.26954 6.73146 6.18764 5.81336 7.32016 5.81336V4.31336C5.35921 4.31336 3.76954 5.90303 3.76954 7.86398H5.26954ZM4.51953 10.5831H19.4562V9.08312H4.51953V10.5831ZM18.7062 7.86398V17.1994H20.2062V7.86398H18.7062ZM5.26954 17.1994L5.26954 7.86398L3.76954 7.86398L3.76954 17.1994L5.26954 17.1994ZM7.32016 5.81336H15.722V4.31336H7.32016V5.81336ZM16.6556 19.25H7.32015V20.75H16.6556V19.25Z"
                          fill="#77C7A2"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "420%" : "36.8px",
                      }}
                    >
                      scheduling
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5424 4.58521C11.7296 4.20597 12.2704 4.20597 12.4576 4.58521L14.4157 8.55208C14.5642 8.85301 14.8512 9.06168 15.1833 9.11021L19.5629 9.75037C19.9814 9.81153 20.1481 10.3258 19.8452 10.6209L16.6773 13.7064C16.4366 13.9409 16.3267 14.2788 16.3835 14.61L17.131 18.9685C17.2025 19.3854 16.7649 19.7033 16.3905 19.5064L12.475 17.4473C12.1777 17.2909 11.8223 17.2909 11.525 17.4473L7.60946 19.5064C7.23509 19.7033 6.79749 19.3854 6.86899 18.9685L7.61652 14.61C7.67332 14.2788 7.56344 13.9409 7.32271 13.7064L4.1548 10.6209C3.85189 10.3258 4.01865 9.81153 4.43705 9.75037L8.81675 9.11021C9.14881 9.06168 9.43578 8.85301 9.58432 8.55208L11.5424 4.58521Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "280%" : "36.8px",
                      }}
                    >
                      Ratings & Reviews
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: mobileView ? "8%" : "24px",
                        height: mobileView ? "auto" : "24px",
                      }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.672 9.6C9.86008 9.06533 10.2313 8.61449 10.72 8.32731C11.2086 8.04013 11.7831 7.93515 12.3417 8.03097C12.9004 8.12679 13.4071 8.41722 13.7721 8.85082C14.1371 9.28443 14.3368 9.83322 14.336 10.4C14.336 12 13.1771 11.7976 12.3 12.8C12.1114 13.0155 12 13.4 12 13.4M12 16H12.008M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
                          stroke="#77C7A2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Box>
                    <Typography
                      className="features"
                      style={{
                        color: "#FFFFFF",
                        fontFamily: "Brockmann",
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: mobileView ? "480%" : "36.8px",
                      }}
                    >
                      Customer Support
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: mobileView ? "100%" : "50%",
                backgroundColor: "#012e1b80",
                padding: "3rem 0",
              }}
            >
              <Box
                sx={{
                  width: "35%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <Box>
                  <Typography
                    className="work"
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Brockmann",
                      fontSize: 24,
                      fontWeight: 600,
                      lineHeight: "28.8px",
                      textAlign: "center",
                    }}
                  >
                    Exactly zero headaches.
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      color: "#FFFFFF",
                      fontFamily: "Brockmann",
                      fontSize: 16,
                      fontWeight: 400,
                      lineHeight: mobileView ? "150%" : "24px",
                      textAlign: "center",
                    }}
                  >
                    We know you’ll save yourself time, money and headaches with
                    FixDen.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* hereh */}

        <Box
          sx={{
            // position: "absolute",
            top: mobileView ? "37%" : "1336px",
            width: "100%",
            backgroundColor: "#77C7A2",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "2.5rem",
            padding: "5rem 0 5rem 0",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "7%",
              position: "relative",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
            }}
          >
            <Typography
              className="tradesperson"
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 48,
                fontWeight: 400,
                lineHeight: "55.2px",
                textAlign: "center",
                // position: "absolute",
                // top: "35%",
              }}
            >
              You didn’t become a tradesperson to chase invoices.
            </Typography>
          </Box>

          <Box
            sx={{
              width: mobileView ? "23%" : "55%",
              height: mobileView ? "0.1%" : "5px",
              backgroundColor: "#FFFFFF",
            }}
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Typography
              style={{
                color: "#6E7375",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              FixDen takes care of{"  "}
              <svg
                width="24"
                height="24"
                top="550"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              >
                <path
                  d="M20 11.2686V12.0046C19.999 13.7297 19.4404 15.4083 18.4075 16.79C17.3745 18.1718 15.9226 19.1826 14.2683 19.6717C12.6139 20.1608 10.8458 20.1021 9.22757 19.5042C7.60934 18.9064 6.22772 17.8015 5.28877 16.3542C4.34981 14.907 3.90383 13.195 4.01734 11.4736C4.13085 9.75223 4.79777 8.11364 5.91862 6.80224C7.03948 5.49083 8.55423 4.57688 10.2369 4.1967C11.9197 3.81651 13.6802 3.99045 15.256 4.69258M9 10.3333L11.6262 12.9596C12.0168 13.3501 12.6499 13.3501 13.0404 12.9596L19 7"
                  stroke="#012e1b80"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Scoping{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              >
                <path
                  d="M20 11.2686V12.0046C19.999 13.7297 19.4404 15.4083 18.4075 16.79C17.3745 18.1718 15.9226 19.1826 14.2683 19.6717C12.6139 20.1608 10.8458 20.1021 9.22757 19.5042C7.60934 18.9064 6.22772 17.8015 5.28877 16.3542C4.34981 14.907 3.90383 13.195 4.01734 11.4736C4.13085 9.75223 4.79777 8.11364 5.91862 6.80224C7.03948 5.49083 8.55423 4.57688 10.2369 4.1967C11.9197 3.81651 13.6802 3.99045 15.256 4.69258M9 10.3333L11.6262 12.9596C12.0168 13.3501 12.6499 13.3501 13.0404 12.9596L19 7"
                  stroke="#012e1b80"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Messaging{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              >
                <path
                  d="M20 11.2686V12.0046C19.999 13.7297 19.4404 15.4083 18.4075 16.79C17.3745 18.1718 15.9226 19.1826 14.2683 19.6717C12.6139 20.1608 10.8458 20.1021 9.22757 19.5042C7.60934 18.9064 6.22772 17.8015 5.28877 16.3542C4.34981 14.907 3.90383 13.195 4.01734 11.4736C4.13085 9.75223 4.79777 8.11364 5.91862 6.80224C7.03948 5.49083 8.55423 4.57688 10.2369 4.1967C11.9197 3.81651 13.6802 3.99045 15.256 4.69258M9 10.3333L11.6262 12.9596C12.0168 13.3501 12.6499 13.3501 13.0404 12.9596L19 7"
                  stroke="#012e1b80"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Bidding{" "}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              >
                <path
                  d="M20 11.2686V12.0046C19.999 13.7297 19.4404 15.4083 18.4075 16.79C17.3745 18.1718 15.9226 19.1826 14.2683 19.6717C12.6139 20.1608 10.8458 20.1021 9.22757 19.5042C7.60934 18.9064 6.22772 17.8015 5.28877 16.3542C4.34981 14.907 3.90383 13.195 4.01734 11.4736C4.13085 9.75223 4.79777 8.11364 5.91862 6.80224C7.03948 5.49083 8.55423 4.57688 10.2369 4.1967C11.9197 3.81651 13.6802 3.99045 15.256 4.69258M9 10.3333L11.6262 12.9596C12.0168 13.3501 12.6499 13.3501 13.0404 12.9596L19 7"
                  stroke="#012e1b80"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Invoicing
            </Typography>
          </Box>
        </Box>

        {/* herej1 */}

        <Box
          sx={{
            width: "100%",
            // backgroundColor: "pink",
            display: "flex",
            flexDirection: mobileView ? "column" : "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: mobileView ? "100%" : "50%",
              height: "25rem",
              backgroundColor: "#FCF2E7",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: mobileView ? "10rem" : "0",
            }}
          >
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 600,
                lineHeight: mobileView ? "100%" : "28.8px",
                textAlign: "center",
              }}
            >
              9/10 busy parents
            </Typography>
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 600,
                lineHeight: "28.8px",
                textAlign: "center",
              }}
            >
              recommend FixDen.
            </Typography>
            <Box
              sx={{
                width: mobileView ? "40%" : "267px",
                height: mobileView ? "2%" : "5px",

                backgroundColor: "#77C7A2",
              }}
            />
            <Box
              sx={{
                left: mobileView ? "5%" : 111,

                width: mobileView ? "40%" : "311px",
                height: mobileView ? "2%" : "72px",
              }}
            >
              <Typography
                style={{
                  color: "#04512F",
                  fontFamily: "Brockmann",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: "24px",
                  textAlign: "center",
                }}
              >
                The 10th parent would have also recommended our service but they
                were too busy cleaning.
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              width: mobileView ? "100%" : "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "7.5rem 0.5rem 0.5rem 0.5rem",
              alignItems: "center",
              height: mobileView ? "35rem" : "25rem",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: mobileView ? "30%" : "172px",
                height: mobileView ? "auto" : "172px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%", // Make the box circular
                overflow: "hidden", // Clip the content outside the circular boundary
                position: "absolute",
                transform: "translateY(-100%)",
                // backgroundColor: "#FFFFFF"
              }}
            >
              <img
                src={require("../../images/wallspace.jpg")}
                alt="wallspace"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
            <Box>
              <Typography
                style={{
                  color: "#FFFFFF",
                  fontFamily: "Brockmann",
                  fontSize: 24,
                  lineHeight: "28.8px",
                  textAlign: "center",
                }}
              >
                Wallspace plaster & paint
              </Typography>
              <Typography
                style={{
                  color: "#04512F",
                  fontFamily: "Brockmann",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: "24px",
                  textAlign: "center",
                }}
              >
                Plaster & Paint Service
              </Typography>
            </Box>

            <Box>
              {[...Array(5)].map((_, index) => (
                <svg
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5245 0.463528C11.6741 0.00287247 12.3259 0.00286996 12.4755 0.463525L14.8064 7.63729C14.8734 7.8433 15.0653 7.98278 15.282 7.98278H22.8249C23.3093 7.98278 23.5106 8.60259 23.1188 8.88729L17.0164 13.3209C16.8412 13.4482 16.7678 13.6739 16.8348 13.8799L19.1657 21.0537C19.3154 21.5143 18.7881 21.8974 18.3963 21.6127L12.2939 17.1791C12.1186 17.0518 11.8814 17.0518 11.7061 17.1791L5.60374 21.6127C5.21189 21.8974 4.68464 21.5143 4.83432 21.0537L7.16522 13.8799C7.23215 13.6739 7.15882 13.4482 6.98358 13.3209L0.881216 8.88729C0.489359 8.60259 0.690746 7.98278 1.17511 7.98278H8.71805C8.93466 7.98278 9.12664 7.8433 9.19357 7.63729L11.5245 0.463528Z"
                    fill="#FFB323"
                  />
                </svg>
              ))}
            </Box>
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 400,
                lineHeight: "24px",
                textAlign: "center",
                padding: "0 5rem",
              }}
            >
              “I was very pleased with Wallspace plaster & paint work. He was
              easy to communicate with and he did the job well and in a timely
              manner. I would hire him again and I can recommend this work.”
            </Typography>
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 16,
                fontWeight: 600,
                fontStyle: "italic",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              Liam, Homeowner
            </Typography>
          </Box>
        </Box>

        {/*herej2*/}

        {/* herej3 */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: mobileView ? "80%" : "271px",
              backgroundColor: "#77C7A2",
              borderRadius: "25px",
              height: "56px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              "&:hover": {
                backgroundColor: "#509d79",
              },
              position: "absolute",
              transform: mobileView ? "translateY(-750%)" : "translateY(-550%)",
              alignSelf: "center",
              justifySelf: "center",
            }}
          >
            <Link
              href="/signup"
              underline="none"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#FFFFFF",
                "&:hover": { color: "#FFFFFF" },
              }}
            >
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 600,
                  lineHeight: "16px",
                  textAlign: "center",
                  fontFamily: "Brockmann",
                }}
              >
                I need work
              </Typography>
              <SvgIcon
                component="svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5 6.5L19.8728 11.8716C19.9576 11.9549 20 12.0641 20 12.1733M14.5 17.5L19.8728 12.475C19.9576 12.3917 20 12.2825 20 12.1733M20 12.1733H4"
                  stroke="#FFFFFF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </SvgIcon>
            </Link>
          </Box>

          <Box
            sx={{
              backgroundColor: "#77C7A233",
              width: "100%",
              padding: mobileView ? "3rem 0" : "2rem 7rem",
            }}
          >
            <Typography
              style={{
                color: "#04512F",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 600,
                lineHeight: "28.8px",
              }}
            >
              Tradespeople Like You
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  width: mobileView ? "20%" : 235,
                }}
              >
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Security Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Appliance Repair Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Masons
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Building Supplies Specialist
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Data Cabling Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Carpenters
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Electricians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Environmental Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Fire Protection Technicians
                </Typography>
              </Box>
              <Box
                sx={{
                  width: mobileView ? "20%" : 235,
                }}
              >
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Flooring Installers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Gas Fitters
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Handymen
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Glass Installers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Heating Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Home Inspectors
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  HVAC Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Landscapers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Locksmiths
                </Typography>
              </Box>
              <Box
                sx={{
                  width: mobileView ? "20%" : 235,
                }}
              >
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Supply Specialists
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Oil Burner Mechanics
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Pest Control Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Painters
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Plumbers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Propane Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Property Managers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Restoration Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Refrigeration Technicians
                </Typography>
              </Box>
              <Box
                sx={{
                  width: mobileView ? "20%" : 235,
                }}
              >
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Roofers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Sheet Metal Workers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Snow Removal Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Tile Setters
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Ventilation Technicians
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Waste Management Specialists
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  Window Installers
                </Typography>
                <Typography
                  style={{
                    color: "#04512F",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: "24px",
                  }}
                >
                  General Contractors
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              padding: "2rem 0",
              width: "100%",
              backgroundColor: "#01522F",
              backgroundImage:
                "url(https://s3-alpha-sig.figma.com/img/f085/1f62/27ce509a11df48f41f77a625d37a6f0d?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=SaZ6YX2PHzeZ~1XlIWbK8JfDM3bI-AkI25MeyAHxEcxOCjRk7YPvO1fONH9U8dIEu5r6EPOPNMSZiSOkotLmQdiJ4ijbU1LUUov2hzx4I8IR3SMc5oYVL7BCbR-UqMi6G1-hIHgTsu-lIC7vTdAubZNEoWCFQYFP6Ecy1bOKme55Ozcxolnw7xFBIr~GcpIU-nfXjuyRgeNpLvf-iu~4XodZcwtcxcEexzHRMNwjMq3hxtegFFQeVkpAj-oC3idbJVjtj2YpctF1EqX7PYyk2Lz9U2oDRNA3ZTYQjyrs8i0N8DtF4g7yBS-MjJkgmWdoPHcDI~ILMMJoDAc6wTC5zg__)",
            }}
          >
            <Typography
              className="description"
              style={{
                color: "#FFFFFF",
                fontFamily: "Brockmann",
                fontSize: 48,
                fontWeight: 400,
                lineHeight: "55.2px",
                textAlign: "center",
              }}
            >
              Looking for services?
            </Typography>
            <Typography
              style={{
                color: "#77C7A2",
                fontFamily: "Brockmann",
                fontSize: 24,
                fontWeight: 600,
                lineHeight: "28.8px",
                textAlign: "center",
              }}
            >
              We’ll connect you with the right tradesperson.
            </Typography>
            <Grid
              alignItems="center"
              justifyContent="center"
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                item
                sx={{
                  width: "auto",
                  padding: "0 1rem",
                  backgroundColor: "#77C7A2",
                  borderRadius: "25px",
                  height: "56px",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  "&:hover": {
                    backgroundColor: "#509d79",
                  },
                  transform: "translateY(100%)",
                }}
              >
                <Link
                  href="/"
                  underline="none"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#FFFFFF",
                    "&:hover": { color: "#FFFFFF" },
                  }}
                >
                  <Typography
                    className="fixden-work-tradespeople"
                    sx={{
                      fontFamily: "Brockmann",
                      fontSize: 16,
                      fontWeight: 600,
                      lineHeight: "16px",
                      textAlign: "center",
                    }}
                  >
                    See how FixDen works for homeowners
                  </Typography>
                  <SvgIcon
                    component="svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5 6.5L19.8728 11.8716C19.9576 11.9549 20 12.0641 20 12.1733M14.5 17.5L19.8728 12.475C19.9576 12.3917 20 12.2825 20 12.1733M20 12.1733H4"
                      stroke="#FFFFFF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </SvgIcon>
                </Link>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              paddingTop: mobileView ? "5rem" : "2rem",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: "3rem",
              paddingLeft: "1rem",
              paddingRight: "1rem",
            }}
          >
            <Box>
              <Typography
                className="features"
                style={{
                  color: "#04512F",
                  fontFamily: "Brockmann",
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: mobileView ? "130%" : "24px",
                }}
              >
                © Steady Innovation Corporation 2024
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                justifyContent: "center",
                width: !mobileView ? "15%" : "30%",
                textAlign: "right",
              }}
            >
              <Box
                sx={{
                  width: mobileView ? "60%" : 235,
                  height: mobileView ? "20%" : 24,
                }}
              >
                <Typography
                  className="features"
                  style={{
                    color: "#77C7A2",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: mobileView ? "130%" : "24px",
                  }}
                >
                  info@fixden.com
                </Typography>
              </Box>
              <Box
                sx={{
                  width: mobileView ? "60%" : 235,
                  height: mobileView ? "20%" : 24,
                }}
              >
                <Typography
                  className="features"
                  style={{
                    color: "#77C7A2",
                    fontFamily: "Brockmann",
                    fontSize: 16,
                    fontWeight: 400,
                    lineHeight: mobileView ? "130%" : "24px",
                  }}
                >
                  Terms
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* herej4 */}
      </Paper>
      {/* </Container> */}
    </ThemeProvider>
  );
}

export default TradesPage;
